import {Action} from '@ngrx/store';

export class AddBijbEventAction implements Action {
  public static readonly type = 'AddBijbEventAction';

  constructor(public name: string, public affiliate: string) {
  }

  public type = AddBijbEventAction.type;
}
